import React from "react";
import CrossPlayMain from "../puzzles/crossword/CrossPlayMain";

/**
 * Crossword play with story: title above the grid, story Card above the clues panel.
 * Route: `/story/play-cross/:id` — `id` is the crossword instance id (`/home/cross/:id`).
 */
export default function StoryCrossPlayPage() {
    return <CrossPlayMain storyPlayLayout />;
}
